import React from 'react';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowDown,
  faArrowUp,
} from "@fortawesome/free-solid-svg-icons";

const isBlanc = move => {
  return isNaN(move);
};

const isZero = move => {
  return (move === '0');
};


const isMoveUp = move => {
  return Number(move) > 0;
};

export const Movement = React.memo(({ move }) => {
  //console.log('NOC  rendered', props)

  if (isBlanc(move)) return null;

  if (isZero(move)) return '=';

  return (
    <div className='move-arrow-number'>
      <div className='move-arrow'>
        {isMoveUp(move)
          ? <FontAwesomeIcon className='move-arrow-up' icon={faArrowUp} />
          : <FontAwesomeIcon className='move-arrow-down' icon={faArrowDown} />
        }
      </div>
      <div className='move-number'>
        {move}
      </div>
    </div>
  )
});

export default Movement